import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import classNames from 'classnames';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import {
  CRON_INTERVAL_DAILY,
  CRON_INTERVAL_WEEKLY,
  CRON_INTERVAL_MONTHLY,
  // CRON_INTERVAL_QUARTERLY,
} from 'components/SchedulingForm/constants';
import Pficon from 'components/Pficon';
import { LETS_TALK_ELITE_URL } from 'containers/App/constants';
import messages from 'components/SchedulingForm/messages';

import QuestionHeader from '../QuestionHeader';

const RECURRENCE_OPTIONS = [
  { value: CRON_INTERVAL_DAILY, label: messages.dailyLabel },
  { value: CRON_INTERVAL_WEEKLY, label: messages.weeklyLabel },
  { value: CRON_INTERVAL_MONTHLY, label: messages.monthlyLabel },
  // { value: CRON_INTERVAL_QUARTERLY, label: messages.quarterlyLabel },
];

const Scheduler = ({
  question,
  onUpdateVariable,
  skipTopMargin,
  hasSchedulingPerk,
}) => {
  const [letsTalkVisible, setLetsTalk] = useState(false);
  const { value } = question;

  const onChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      onUpdateVariable(newValue);
    },
    [onUpdateVariable],
  );

  return (
    <React.Fragment>
      <div className="flex flex-items-center">
        <QuestionHeader
          title={question.body}
          note={question.note}
          skipTopMargin={skipTopMargin}
        />
      </div>

      <div>
        <div className="position-relative">
          {letsTalkVisible && (
            <div
              className="position-absolute padding-xs"
              style={{ zIndex: 2, left: '25%', top: -5, right: -5, bottom: -5 }}
              onMouseLeave={() => setLetsTalk(false)}
            >
              <div className="flex flex-items-center flex-justify-center background-grey-1 h-full">
                <span className="margin-right-xs">
                  <FormattedHTMLMessage
                    {...messages.featureAvailableOnElitePlan}
                  />
                </span>
                <a
                  className={classNames(
                    'color-grey-1-important',
                    'text-size-secondary',
                    'padding-horizontal-xs',
                    'padding-vertical-tiny',
                    'border-radius-level-1',
                    'cursor-pointer',
                    'opacity-80-hover',
                    'transition-normal',
                  )}
                  style={{ backgroundColor: '#20e27d' }}
                  target="_blank"
                  href={LETS_TALK_ELITE_URL}
                >
                  <FormattedMessage {...messages.letsTalk} />
                </a>
              </div>
            </div>
          )}
          <Radio.Group
            onChange={onChange}
            value={value}
            name={question.name}
            className="ant-button-group w-full shadow-color-1-5-level-2"
          >
            <Radio.Button
              key="none"
              className={classNames(
                'color-grey-10 ',
                'olor-grey-10-hover',
                'padding-horizontal-none',
                'text-align-center',
                'border-radius-left-level-1',
              )}
              value={undefined}
              style={{ width: '25%' }}
            >
              <FormattedMessage {...messages.noneLabel} />
            </Radio.Button>
            {RECURRENCE_OPTIONS.map((option, index) => (
              <Radio.Button
                key={String(option.value)}
                className={classNames(
                  'color-grey-10',
                  'background-grey-1',
                  'padding-horizontal-none',
                  'text-align-center',
                  {
                    'border-radius-right-level-1':
                      index === RECURRENCE_OPTIONS.length - 1,
                  },
                )}
                value={option.value}
                style={{ width: '25%' }}
                disabled={!hasSchedulingPerk}
              >
                {hasSchedulingPerk ? (
                  <FormattedMessage {...option.label} />
                ) : (
                  <div
                    className="cursor-default background-color-1"
                    onMouseEnter={() => setLetsTalk(true)}
                  >
                    <FormattedMessage {...option.label} />
                    <Pficon
                      className="color-grey-10 margin-left-tiny"
                      type="lock3"
                    />
                  </div>
                )}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </div>
    </React.Fragment>
  );
};

Scheduler.propTypes = {
  question: PropTypes.object,
  onUpdateVariable: PropTypes.func.isRequired,
  skipTopMargin: PropTypes.bool,
  hasSchedulingPerk: PropTypes.bool,
};

export default Scheduler;
